import { PHONE } from '../constants/site';
import { useWeb3Form } from '../hooks/useWeb3Form';

/**
 * Web3Forms contact form — name, email, phone (required on all inquiry forms).
 */
export default function ContactInquiryForm({
  subject,
  successMessage = 'Thank you. We will contact you shortly.',
  submitLabel = 'Submit',
  showTopic = false,
  showMessage = true,
  messageRequired = true,
  bookingDetails = '',
  className = 'contact-inquiry-form',
  onSuccess,
}) {
  const { handleSubmit, status, submitting, isSuccess } = useWeb3Form({
    subject,
    successMessage,
    onSuccess,
    beforeSubmit: (formData) => {
      if (bookingDetails) {
        const userMsg = String(formData.get('message') || '').trim();
        formData.set(
          'message',
          `Booking / inquiry details:\n${bookingDetails}${userMsg ? `\n\nAdditional notes:\n${userMsg}` : ''}`
        );
      }
    },
  });

  return (
    <form className={className} onSubmit={handleSubmit}>
      <input type="checkbox" name="botcheck" className="sr-only" tabIndex={-1} autoComplete="off" />

      <label>
        Full name
        <input name="name" type="text" required disabled={submitting} placeholder="Your full name" />
      </label>
      <label>
        Email
        <input name="email" type="email" required disabled={submitting} placeholder="you@email.com" />
      </label>
      <label>
        Phone number
        <input name="phone" type="tel" required disabled={submitting} placeholder={`e.g. ${PHONE}`} />
      </label>

      {showTopic && (
        <label>
          Topic
          <select name="topic" defaultValue="booking" disabled={submitting}>
            <option value="booking">Booking help</option>
            <option value="change">Change / cancel</option>
            <option value="payment">Payment</option>
            <option value="other">Other</option>
          </select>
        </label>
      )}

      {showMessage && (
        <label>
          Message
          <textarea
            name="message"
            rows={4}
            required={messageRequired}
            disabled={submitting}
            placeholder={bookingDetails ? 'Any special requests (optional)' : 'How can we help?'}
          />
        </label>
      )}

      <button type="submit" className="btn-gold" disabled={submitting}>
        {submitting ? 'Sending…' : submitLabel}
      </button>

      {status && !submitting && (
        <p className={isSuccess ? 'form-success' : 'form-error'} role="status">
          {status}
        </p>
      )}
    </form>
  );
}
